import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setAuthToken, fetchActiveUserIfNeeded } from 'Store/users/actions';
import { getAuthToken } from 'Store/reducers';
import Loading from 'Components/Loading';
import { ISRAEL_STUDENT_DEMO_TOKEN } from 'Settings';

class IsraelDemoWrapper extends React.Component {
  componentDidMount() {
    this.props.setAuthToken(ISRAEL_STUDENT_DEMO_TOKEN);
    this.props.fetchActiveUserIfNeeded();
  }

  componentWillUnmount() {
    this.props.setAuthToken(null);
  }

  render() {
    const { authToken, children } = this.props;
    if (!authToken) {
      return <Loading />;
    }
    return children;
  }
}

IsraelDemoWrapper.propTypes = {
  setAuthToken: PropTypes.func.isRequired,
  fetchActiveUserIfNeeded: PropTypes.func.isRequired,
  authToken: PropTypes.string,
  children: PropTypes.node,
};

export default connect(state => ({ authToken: getAuthToken(state) }), {
  setAuthToken,
  fetchActiveUserIfNeeded,
})(IsraelDemoWrapper);
